import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import {
  FORGOT_PASS_PATH,
  RESET_PASS_PATH,
  SIGNIN_PATH,
  SIGNUP_PATH,
  SIGNUP_VERIFY_EMAIL_PATH,
} from "features/Auth/routes";
import {
  collapsedSidebarSelect,
  hasBannerSelect,
  userDetailSelect,
} from "Layout/slice/selector";

import { logoBetaAIDark, SidebarUpgradeLogo } from "assets/icons";
import { AppMenu } from "./AppMenu";
import { contains, isLoggedIn } from "utils";
import { PLANS_PATH } from "features/Plans/routes";
import { RecommendCardContainer, SidebarContainer } from "./Sidebar.styles";
import { MAIN_ACCOUNT_PATH } from "features/Account/routes";
import { VERIFY_PHONE_PATH, WELCOME_PATH } from "features/Auth/routes";
import { themeState } from "Layout/slice/selector";
import { ProfileMenu } from "./ProfileMenu";
import { togglePurchasePlanModal } from "Layout/slice/index";
import { HELP_CENTER_V2_PATH } from "features/HelpCenter/routes";
import { isFreeUser } from "utils/index";
import {
  IconBackArrow,
  surmountLogo,
  SidebarSurmountLogo,
} from "assets/icons/index";
import { useNavigation } from "utils/navigate";

export const Sidebar = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const userDetails = useSelector(userDetailSelect);
  const { navigateBack } = useNavigation();

  const theme = useSelector(themeState);
  const hasBanner = useSelector(hasBannerSelect);
  const collapsed = useSelector(collapsedSidebarSelect);

  const [active, setActive] = useState("");

  const isYearlyPlan = userDetails?.surmount_plan?.interval === "yearly";
  const isMonthlyPlan = userDetails?.surmount_plan?.interval === "monthly";
  const isFreePlan = isFreeUser();

  useEffect(() => {
    setActive(pathname);
  }, [pathname]);

  const hideSidebar =
    contains(pathname, SIGNUP_PATH) ||
    contains(pathname, SIGNIN_PATH) ||
    contains(pathname, FORGOT_PASS_PATH) ||
    contains(pathname, SIGNUP_VERIFY_EMAIL_PATH) ||
    contains(pathname, RESET_PASS_PATH) ||
    contains(pathname, WELCOME_PATH) ||
    contains(pathname, PLANS_PATH) ||
    contains(pathname, VERIFY_PHONE_PATH) ||
    contains(pathname, MAIN_ACCOUNT_PATH);

  const getLogo = () => {
    let logo = SidebarSurmountLogo;
    if (theme === "dark") {
      logo = logoBetaAIDark;
    }
    return logo;
  };

  const handleUpgradePlan = () => {
    dispatch(togglePurchasePlanModal(true));
  };

  const handleBackButton = () => {
    navigateBack();
  };

  return (
    <SidebarContainer
      hasBanner={hasBanner}
      className={classNames({
        collapsed: collapsed,
        "d-none": hideSidebar || !isLoggedIn(),
      })}
    >
      <div className="sidebar">
        <div className="sidebar-inner">
          <div
            className={classNames("sidebar-layout", {
              "sidebar-account-layout": contains(location.pathname, "account"),
            })}
          >
            {contains(location.pathname, "account") ? (
              <>
                <div className="mobile-view ">
                  <div className="account-header">
                    <Link to={"/"} className="link-logo">
                      <img
                        alt="logo"
                        src={surmountLogo}
                        className="main-logo m-0 mt-1"
                      />
                    </Link>
                    <IconBackArrow
                      variant="secondary"
                      size="small"
                      className="btn-back-secondary-page"
                      onClick={handleBackButton}
                    />
                    <span className="item-content">Account settings</span>
                  </div>
                </div>{" "}
                <div className="desktop-view">
                  <Link to={"/"} className="link-logo">
                    <img alt="logo" src={getLogo()} className="main-logo" />
                  </Link>
                </div>
              </>
            ) : (
              <Link to={"/"} className="link-logo">
                <img
                  alt="logo"
                  src={getLogo()}
                  className="main-logo"
                  height={38}
                  width={140}
                />
              </Link>
            )}

            <div className="sidebar-content">
              <nav className="menu">
                {contains(pathname, MAIN_ACCOUNT_PATH) ||
                contains(pathname, HELP_CENTER_V2_PATH) ? (
                  <ProfileMenu active={active} />
                ) : (
                  <AppMenu active={active} />
                )}
              </nav>
            </div>
            {!isYearlyPlan && (isMonthlyPlan || isFreePlan) && (
              <RecommendCardContainer
                className={classNames({
                  free: isFreePlan,
                  "account-recommend-card": contains(
                    location.pathname,
                    "account"
                  ),
                })}
              >
                <div className="upgrade-content">
                  <div className="upgrade-text">
                    <p className="upgrade-title">Upgrade to Surmount Premium</p>
                    <p className="upgrade-description">
                      Access automated strategies, connect broker accounts, and
                      enjoy live trading!
                    </p>
                  </div>
                  <div className="upgrade-visual">
                    <button
                      className="arrow-button"
                      onClick={handleUpgradePlan}
                    >
                      &#8599;
                    </button>
                    <div className="placeholder-image">
                      <img src={SidebarUpgradeLogo} height={75} width={75} />
                    </div>
                  </div>
                </div>
              </RecommendCardContainer>
            )}
          </div>
        </div>
      </div>
    </SidebarContainer>
  );
};
